<!--
  入驻
-->
<template>
  <div class="settle-in-content" ref="settleIn">
    <titleHeader :hide-nav="true" title="我要入驻"></titleHeader>
    <van-field v-model="name" label="供应商名称" required size="large"  placeholder="请输入供应商名称" />
    <van-field v-model="servicePhone" label="客服电话" @blur="verifyService" :error-message="serviceError" required size="large" placeholder="请输入客服电话" />
    <van-field v-model="phone" label="手机号码" @blur="verifyPhone" :error-message="phoneError" required size="large" placeholder="请输入手机号码" />
    <van-field v-model="password" label="密码" @blur="verifyPwd" :error-message="passwordError" type="password" required size="large" placeholder="请输入密码" />
    <van-field v-model="password2" label="密码确认" type="password" required size="large" placeholder="请再次输入密码" />

    <van-field
      v-model="phoneCode"
      center
      required
      size="large"
      label="短信验证码"
      placeholder="请输入短信验证码"
    >
      <van-button slot="button" size="small" color="#45C5DA" type="primary" @click="sendCode">
        <span v-show="!display.showWait">发送验证码</span>
        <span v-show="display.showWait">{{waitSecond}}s</span>
      </van-button>
    </van-field>
    <div class="business-info">
      <label class="label">
        工商信息
      </label>
      <img  :src="item" v-for="item in imageList" alt="">
      <upload-image
        ref="uploadImage"
        :multiple="true"
        style="display: inline-block"
        :max-size="3"
        :preview-size="75"
        @getImage="getImage">
        <self-button
          type="primary"
          style="margin-left: 0;"
        >
          点击上传
        </self-button>
      </upload-image>
    </div>
    <div class="confirm-settle" @click="submitSettle">确认入驻</div>
    <div class="need-help-tip" @click="showTips">需要帮助？</div>
    <van-action-sheet cancel-text="取消" v-model="display.tips" :actions="actions" @select="selectTip" />
    <geetest
      ref="geetest"
      :phone="phone"
      :page-code="pageCode"
      :val-code="pageCode"
      @send-code-success="handlerSendCodeSuccess"
      @send-code-error="handlerSendCodefailed"
    ></geetest>
  </div>
</template>

<script>
  let md5 = require('md5');
  import uploadImage from 'components/upload-image';
  import { Toast } from 'vant';
  import geetest from "components/geetest/geetest.vue";
  import { randomString } from 'common/js/utils';
  import api from 'api/user';
  export default {
    components: {
      uploadImage,
      geetest
    },
    data() {
      return {
        display: {
          tips: false,
          showWait: false
        },
        name: '',
        servicePhone: '',
        phone: '',
        password: '',
        password2:'',
        imageList: [], //工商照片
        phoneCode: '',
        serviceError: '', //客服电话错误提示
        phoneError: '', //电话错误提示
        passwordError: '', //密码错误提示
        actions: [{name: '工作时间：9:00 - 17:30', id: 1}, {name: '400-100-1392', id:2}],
        pageCode: randomString(8), //手机验证所需要的随机字符串
        waitSecond: 60
      }
    },
    mounted() {
      this.$refs.settleIn.style.height = window.innerHeight + 'px';

    },
    methods: {
      getImage(img) {
        console.log(img);
        this.imageList = img;
      },
      //验证客服电话手机号
      verifyService() {
        /*if (this.servicePhone && !(/^1[3456789]\d{9}$/.test(this.servicePhone))){
          this.serviceError = '手机号格式不正确';
        }else{
          this.serviceError = '';
        }*/
      },
      //验证手机号
      verifyPhone() {
        if (this.phone && !(/^1[3456789]\d{9}$/.test(this.phone))){
          this.phoneError = '手机号格式不正确';
        }else{
          this.phoneError = '';
        }
      },
      //验证密码
      verifyPwd() {
        if (this.password && this.password.length < 6) {
          this.passwordError = '密码不得小于6位';
        }else{
          this.passwordError = '';
        }
      },
      //发送验证码
      sendCode() {
        if (this.display.showWait) return
        if ( this.phone === '' ) {
          Toast('请输入手机号');
          return
        }
        if (this.phone && (/^1[3456789]\d{9}$/.test(this.phone))){
          this.$refs.geetest.verify();
        }
      },
      // 发送验证码成功
      handlerSendCodeSuccess(res) {
        this.display.showWait = true;
        this.secondWait()
      },
      // 发送错误
      handlerSendCodefailed(err) {
        console.log(err);
      },
      //确认入驻
      submitSettle() {
        console.log(this.imageList);
        if (this.name === '') {
          Toast('供应商名称不能为空');
          return;
        }
        if (this.servicePhone === '') {
          Toast('客服电话不能为空');
          return;
        }
        if (this.serviceError) return;
        if (this.phone === '') {
          Toast('手机号不能为空');
          return;
        }
        if (this.phoneError) return;
        if (this.password === '') {
          Toast('密码不能为空');
          return;
        }
        if (this.passwordError) return;
        if (this.password !== this.password2) {
          Toast('两次密码不一致!');
          return;
        }
        /*if (this.phoneCode === '') {
          Toast('验证码不能为空');
          return;
        }*/
        if (this.imageList.length === 0) {
          Toast('请上传工商信息');
          return;
        }
        const imgList = this.imageList.map(item=>item.url);
        const params = {
          name: this.name,
          telephone: this.servicePhone,
          mobile: this.phone,
          pwd: md5(this.password),
          picUrl: imgList,
          smsCode: this.phoneCode
        }
        console.log(params);
        api.settleIn(params)
        .then(res=>{
          this.$router.push({
            name: 'mine'
          })
          Toast.success('申请已提交')
        })
        .catch(err=>{
          Toast.fail(err.message)
        })
      },
      //查看帮助
      showTips() {
        this.display.tips = true;
      },
      selectTip(item) {
        if (item.id === 2) {
          window.location.href = `tel://${item.name}`
        }
      },
      secondWait: function() {
        let _this = this;
        _this.setInercalID = setTimeout(function() {
          if (_this.waitSecond > 0) {
            _this.waitSecond = _this.waitSecond - 1;
            _this.secondWait();
          } else {
            _this.display.showWait = false;
            clearTimeout(_this.setInercalID);
            _this.waitSecond = 60;
          }
        }, 1000);
      },
    }
  }
</script>

<style lang="scss">
  .settle-in-content{
    position: relative;
    .van-cell--large .van-cell__title{
      font-size: 16px;
    }
  }
</style>
<style scoped lang="scss">
  @import "common/sass/theme.scss";
  .business-info{
    position: relative;
    padding: 16px;
    font-size: 16px;
    label{
      display: inline-block;
      width: 24vw;
      vertical-align: top;
    }
    &:before{
      position: absolute;
      left: 2.133vw;
      color: #ee0a24;
      font-size: 3.733vw;
      content: '*';
    }
  }
  .confirm-settle{
    width: 80vw;
    margin: 30px auto;
    border: 1px solid #ddd;
    padding: 10px 10px;
    text-align: center;
    font-size: 13px;
    border-radius: 5px;
    background: $theme-color;
    color: #fff;
  }
  .need-help-tip{
    position: absolute;
    bottom: 20px;
    color: $theme-color;
    margin-left: 16px;
  }
</style>